module.exports = __webpack_public_path__ + "img/place-phone.6aad4b73.png";